import { AxiosInstance } from 'axios'

import { baseService } from './base.service'
import { IBaseService } from './interfaces/base-service.interface'

import { CommentReaction, CreateCommentDto, CreateCommentReactionDto, UpdateCommentDto } from '@/types/comment.type'

export class CommentService {
  private static instance: CommentService
  private readonly api: AxiosInstance

  constructor(private readonly baseService: IBaseService) {
    this.api = this.baseService.getClient()
  }

  public static getInstance(baseService: IBaseService): CommentService {
    if (!CommentService.instance) {
      CommentService.instance = new CommentService(baseService)
    }
    return CommentService.instance
  }

  createComment = async (commentDto: CreateCommentDto) => {
    const { data } = await this.api.post('/comment/create', commentDto)
    return data
  }

  updateComment = async (id: number, commentDto: UpdateCommentDto) => {
    const { data } = await this.api.put(`/comment/update/${id}`, commentDto)
    return data
  }

  deleteComment = async (id: number) => {
    const { data } = await this.api.delete(`/comment/${id}`)
    return data
  }

  getCommentReactions = async (id: number): Promise<Array<CommentReaction>> => {
    const { data } = await this.api.get(`/comment/${id}/reactions`)
    return data?.reactions || []
  }

  createCommentReaction = async (id: number, reactionDto: CreateCommentReactionDto): Promise<CommentReaction> => {
    const { data } = await this.api.post(`/comment/${id}/react`, reactionDto)
    return data
  }
}

const commentService = CommentService.getInstance(baseService)

export default commentService
